import React from 'react';

const makeTitle = (title) => {
  const text = title.map((el,index) => {
    return <span key = {index} className = {el.color === "main" ? "color-main" : ""}> {el.break ? <br/> : ""}{el.text} </span>
    })
  return text;
}

export default makeTitle;